import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const RemoteFeatures = () => {
    return (
        <div className="homebreeze">
            <div className="Homebanner-txt">
                <h2>Breeze at your fingertips</h2>
                <p className='boost'>Boost Mode | Timer | 6-Speed Controls</p>
                <p>Experience the year-round comfort with reversible mode and the ease of speed control from up to a distance of 20 ft.</p>
            </div>
            <div className="Homebanner-img">
                <LazyLoadImage 
                    src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/homeremote.png"}
                    className="img-fluid" 
                    alt="An image of Colorbot Ceiling fan Remote"
                    effect="blur"
                />
            </div>
        </div>
    );
};

export default React.memo(RemoteFeatures);
